export default "__VITE_ASSET__b396afdf__"